import React, { useRef, useState } from 'react';

import { auth } from '../../FirebaseUtils';
import { 
    onAuthStateChanged, 
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    updateEmail,
    updatePassword,
} from "firebase/auth";

function RegisterPage() {

    const emailRef = useRef();
    const passwordRef = useRef();

    async function register(e) {
        console.log('register');
        
        try {
            await createUserWithEmailAndPassword(auth, emailRef.current.value.trim(), passwordRef.current.value);
        }
        catch(error) {

            if (error.code) {
                if (error.code === "auth/email-already-in-use") {
                    //setError("You've already signed up. Please log in.");
                }
                else if (error.code === "auth/invalid-email") {
                    //setError("This email is invalid.");
                }
                else if (error.code === "auth/operation-not-allowed") {
                    //setError("This sign up method is not allowed.");
                }
                else if (error.code === "auth/weak-password") {
                    //setError("Password must be at least 6 characters.");
                }
                else {
                    //setError('Failed to create an account. Error: ' + JSON.stringify(error));
                }
            }
            else {
                //setError('Failed to create an account. Error: ' + JSON.stringify(error));
            }
        }
    }

    return (
        <div>
        {/*<form onSubmit={register}>
            Email: <input type="text" /><br />
            Password: <input type="text" /><br />
            <input type="submit" /><br />
        </form>*/}

            Email: <input type="email" ref={emailRef} /><br />
            Password: <input type="password" ref={passwordRef} /><br />
            <button onClick={register}>Register</button>

        </div>
    );
}

export default RegisterPage;
